import { render, staticRenderFns } from "./channelRateUpLimit.vue?vue&type=template&id=35a9e049&scoped=true&"
import script from "./channelRateUpLimit.vue?vue&type=script&lang=js&"
export * from "./channelRateUpLimit.vue?vue&type=script&lang=js&"
import style0 from "./channelRateUpLimit.vue?vue&type=style&index=0&id=35a9e049&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a9e049",
  null
  
)

export default component.exports